import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  RetailVdpBox,
  RetailVdpHeading,
  Container,
  RetailVdpMessage,
  RetailVdpButton
} from './Styles';

const RetailVdpShare = ({ onRetailVDPOpen }) => {
  return (
    <RetailVdpBox data-testid="vdp-retail-share">
      <RetailVdpHeading data-testid="retail-share-heading">
        {/* Share this vehicle with a customer */}
        <FormattedMessage id="vdp.retail.share" />
      </RetailVdpHeading>
      <Container>
        <RetailVdpMessage data-testid="retail-share-message">
          {/* Create a customer-friendly view of this page that you’re in control of to send to a potential customer. */}
          <FormattedMessage id="vdp.retail.message" />
        </RetailVdpMessage>
        <RetailVdpButton
          onClick={onRetailVDPOpen}
          data-testid="retail-share-button"
        >
          {/* Create Customer Link */}
          <FormattedMessage id="vdp.retail.link" />
        </RetailVdpButton>
      </Container>
    </RetailVdpBox>
  );
};

export default RetailVdpShare;
